<template>
  <transition name="forup">
    <div class="bg-white nosuit-box"  v-if="boxshow">
      <div class="warry" id="nosuitmode">
        <!--头部-->
        <div class="nosuitmodehead" style="border-top: 1px solid rgba(206, 182, 23, 0.4); ">
          <bg-yun>
            <div class="suit-name text-center">
              {{order.name}}
              <img height="17" :src="icon" v-for="icon in order.iconPath">
            </div>
            <div class="nosuit-sub-title suit-price flex-layout  padding-10">
              <div class="flex-1 color-yellow font-1 text-nowrap">{{order.price}}元<span v-if="order.standard">/{{order.standard}}</span></div>
              <div class="flex-1 color-blue font-1 text-nowrap" style="display: flex;">
                <img v-if="order.memberprice<order.price"
                     src="../../assets/image/vipIco.svg" alt="" width="18" style="align-self: center;pointer-events: none;">
                <span v-if="order.memberprice<order.price" >{{order.memberprice}}元
                  <span v-if="order.standard">/{{order.standard}}</span>
                </span>
              </div>
              <div class="flex-1 text-right" style="flex: 1.3">
              <span class="suit-num" @click.stop="clickSub()">
                <img src="../../assets/image/subIcon.svg" width="35" style="vertical-align: middle;pointer-events: none;">
              </span>
                <span class="suit-num">{{order.num}}
                  <span v-if="order.minOrderNum>1 && order.num === order.minOrderNum"
                        style="font-size: 10px;color: orangered;margin-left: 3px">起点</span>
                </span>
                <span class="suit-num" @click.stop="clickAdd()">
                 <img src="../../assets/image/addIcon.svg" width="35" style="vertical-align: middle;pointer-events: none;">
                </span>
              </div>
            </div>
          </bg-yun>
        </div>

        <div class="nosuitmodecontent">
          <scroller ref="Scroller">
            <!--多规格-->
            <div class="bg-yellow magin-t-6" v-if="order.standards&&order.standards.length>1">
              <bg-yun>
                <div class="flex-layout padding-10">
                  <div class=" flex-1 font-0-8 text-center">请选择规格</div>
                </div>
                <div class="flex-wrap padding-5 stands-item" v-for="stand in order.standards" @click.stop="clickStand(order.standards,stand)">
                  <div class=" flex-1 padding-t-b-10 font-0-8">
                    <img v-if="stand.isSelect" src="../../assets/image/okIco.png" width="25" style="vertical-align: middle;pointer-events: none;">
                    <img v-if="!stand.isSelect" src="../../assets/image/okIco1.png" width="25" style="vertical-align: middle;pointer-events: none;">
                    <span class="font-1 magin-l-10">{{stand.standard}}</span>
                  </div>
                  <div class="flex-1 color-blue text-nowrap font-0-9 padding-t-b-10"  v-if="stand.memberprice>0 && stand.memberprice!==stand.price">
                    <img src="../../assets/image/vipIco.svg" alt="" width="18" style="vertical-align: middle;margin-top: -3px;">
                    <span>{{stand.memberprice}}元</span>
                  </div>
                  <div class="flex-1 color-yellow text-center text-nowrap padding-t-b-10 font-0-9">
                    {{stand.price}}元
                  </div>
                </div>
              </bg-yun>
            </div>

            <!--做法-->
            <div class="bg-yellow magin-t-6" v-if="order.remark&&order.remark.length>0">
              <bg-yun>
                <div class="flex-layout padding-10">
                  <div class=" flex-1 font-0-8 text-center">
                    请选择做法
                  </div>
                </div>
                <div class="flex-wrap padding-5 stands-item" v-for="remk in order.remark" @click.stop="clickRemk(remk)">
                  <div class=" flex-1 font-0-8 padding-t-b-10">
                    <img v-if="remk.isSelect" src="../../assets/image/okIco.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <img v-if="!remk.isSelect" src="../../assets/image/okIco1.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <span class="font-1 magin-l-10 "><span v-if="remk.isSelect" class="color-yellow">{{remk.num}}×</span>{{remk.name}}</span>
                  </div>
                  <div class="flex-1 color-yellow padding-t-b-10 text-nowrap text-center font-0-9">
                    <span v-if="remk.price>0">{{remk.price}}元</span>
                    <span v-else="">免费</span>
                  </div>
                </div>
              </bg-yun>
            </div>

            <!--配菜-->
            <div class="bg-yellow magin-t-6" v-if="sideDish.length>0&&order.memoflag==1" id="sideDish">
              <bg-yun>
                <div class="padding-10 menuItem font-0-8 text-center">请选择配菜</div>
                <div class="nosuit-sidedish-item padding-10 menuItem font-0-8 flex-layout" v-for="sideorder in  sideDish" @click.stop="clickSideOrder(sideorder)">
                  <div class="width-auto text-nowrap">
                    <img v-if="sideorder.isSelect" src="../../assets/image/okIco.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <img v-if="!sideorder.isSelect" src="../../assets/image/okIco1.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <span class="magin-l-6" >
                      <span v-if="sideorder.isSelect" class="color-yellow">{{sideorder.num}}×</span>{{sideorder.name}}</span>
                  </div>
                  <div class="width-auto color-blue">
                    <img v-if="sideorder.memberprice<sideorder.price" src="../../assets/image/vipIco.svg" alt="" width="15" style="vertical-align: middle;margin-top: -3px;">
                    <span v-if="sideorder.memberprice<sideorder.price">{{sideorder.memberprice}}元/{{sideorder.standard}}</span>
                  </div>
                  <div class="width-auto color-yellow text-right text-nowrap">
                    {{sideorder.price}}元/{{sideorder.standard}}
                  </div>
                </div>
              </bg-yun>
            </div>
            <!--图片加描述-->
            <div class="magin-t-6" style="font-size: 0" v-if="order.picMode > 0 || order.desc">
              <bg-yun>
                <img v-if="order.picMode > 0" :src="order.picPath" onerror="this.src='static/image/error.jpg'" width="100%">
                <div class="padding-5 font-0-9" v-if="order.desc">
                  {{order.desc}}
                </div>
              </bg-yun>
            </div>
          </scroller>
        </div>
      </div>
      <div class="suit-bottom flex-layout text-center font-1-2" v-if="boxshow">
        <div class="btm-btn flex-1 color-gray-yellow"  @click.stop="btnCancel()">
          <img src="../../assets/image/cancel.svg" width="20" style="vertical-align: middle;padding-bottom: 2px">
          返回
        </div>
        <div class="btm-btn flex-1 bg-gray-yellow color-white"  @click.stop="btnOK()">
          <img src="../../assets/image/ok.svg" width="25" style="vertical-align: middle;padding-bottom: 2px">
          确定
        </div>
      </div>
      <alertnum ref="alertnum"></alertnum>
    </div>
  </transition>
</template>
<script>
  import ServiceUtil from '../../service/ServiceUtils';
  import ServiceDialog from "../../service/ServiceDialog";
  import bgyun from "../bg-yun/bgyun";
  import alertnum from '../alertnum/alertNum';
  export default {
    name: 'nosuitmode',
    data () {
      return{
        boxshow:false,
        order:{},
        type:{},
        sideDish:ServiceUtil.sideDish,
        _callback:""
      }
    },
    components:{
      'bg-yun':bgyun,
      'alertnum':alertnum
    },
    methods:{
      //显示模型
      togglebox:function(type,order,callback){
        order.num =  Math.max(order.minOrderNum || 1,1);
        this._callback = callback;
        this.boxshow = !this.boxshow;
        this.order = order;
        this.type = type;
        this.sideDish.forEach(function(item){
          item.isSelect=false;
        });
        this.order.remark.forEach(function(item){
          item.isSelect = false;
        });
        this.$nextTick(function() {
          document.querySelector("#nosuitmode").scrollTop = 0;
        });
        console.log(this.order)
      },
      //点击配菜
      clickSideOrder:function(order){
        order.num = 1;
        if(order.isSelect){
          order.isSelect = !order.isSelect;
          this.$forceUpdate();
        }else {
          this.$refs.alertnum.togglebox(this.type,order,(res)=>{
            order.isSelect=!order.isSelect;
            this.$forceUpdate();
          });
        }
      },
//      点击多规格
      clickStand:function(stands,stand){
        stands.forEach(function(item){
          item.isSelect = false;
        });
        stand.isSelect = true;
        this.order.price = stand.price;
        this.order.memberprice = stand.memberprice;
        this.order.standard = stand.standard;
      },
      /**
       * 提交时处理配菜的方法
       * @returns {{memo: string, menuItem: Array}}
       */
      dealSideDish:function(){
        var menuItem = [];
        var memo = [];
//        遍历配菜数据
        this.sideDish.forEach(function(item){
          if(item.isSelect&&item.price!=0){
            let _obj = {
              code: item.code || "",
              name: item.name,
              sndname: item.sndname || "",
              standard: item.standard || '',
              price: item.price,
              memberprice:item.memberprice || '0',
              num: item.num,
              memo: "",
              memberNo:""
            };
            menuItem.push(_obj);
          }
        });
//遍历多规格数据
        this.order.remark.forEach(function(item){
          if(item.isSelect&&item.price>0){
            var _obj = {
              code: "",
              name: item.name,
              sndname: item.sndname || "",
              standard: item.standard || '',
              price: item.price,
              memberprice:item.memberprice || '0',
              num: item.num,
              memo: "",
              memberNo:""
            };
            menuItem.push(_obj);
          }else if(item.isSelect) {
            memo.push(item.name);
          }
        });
        return {
          menuItem:menuItem,
          memo:memo.join(',')
        };
      },

      /**
       * 点击做法
       */
      clickRemk:function(remk){
        remk.num=1;
        if(!remk.isSelect&&remk.price>0) {
          this.$refs.alertnum.togglebox(this.type,remk,(res)=>{
            remk.isSelect=!remk.isSelect;
            this.$forceUpdate();
          });
        }else {
          remk.isSelect = !remk.isSelect;
          this.$forceUpdate();
        }
      },
      //点击取消
      btnCancel: function(){
        this.boxshow = !this.boxshow;
      },


      //点击确认
      btnOK:function(){
        let type = {
          code:this.type.code,
          name:this.type.name,
          ename:this.type.sndname||"",
          isGroup:0
        };

        let order = {
          code: this.order.code,
          name: this.order.name,
          sndname: this.order.sndname,
          price: this.order.price,
          memberprice: this.order.memberprice||"0",
          standard: this.order.standard,
          num: this.order.num,
          drink:this.order.drink||0,
          menuItem: this.dealSideDish().menuItem,
          memo: this.dealSideDish().memo
        } ;

        let addFood =()=> {
         ServiceUtil.setNoSuitData(type,order) ;
          this.boxshow = false;
          if(this._callback){
            this._callback();
          }
          this.$forceUpdate();
        };

        if(order.menuItem && order.menuItem.length>0){
          addFood();
        }else if(this.order.memoflag==1 && order.menuItem && order.menuItem.length == 0){
          ServiceDialog.confirm('温馨提示','该菜品有配菜是否添加 ？',()=>{
            this.$nextTick(function() {
              this.$refs.Scroller.scrollBy(0,document.getElementById('sideDish').offsetTop);
            });
          },()=>{
            addFood();
          },'去添加','不添加');
        }else {
          addFood();
        }
      },
//      点击加号
      clickAdd(){
        this.order.num = this.order.num+1;
        this.$forceUpdate();
      },
//      点击减号
      clickSub(){
        this.order.num--;
        this.order.num =  Math.max(this.order.num,this.order.minOrderNum || 1);
        this.$forceUpdate();
      }
    },
    mounted(){
      this.sideDish=ServiceUtil.sideDish;
      this.order = ServiceUtil.config.order;
      this.type = ServiceUtil.config.type;
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .magin-t-6{
    margin-top: 6px;
  }
  .color-white{color:#ffffff}
  .bg-gray-yellow{background:#CEB66B}
  .color-gray-yellow{color:#CEB66B}
  .padding-5{padding: 5px;}
  .font-0-8{font-size: 0.8em;}
  .padding-10{padding: 10px;}
  .warry{position: absolute;top: 51px;bottom: 0;left: 0;right: 0;
    background-color:white;overflow-y:scroll;-webkit-overflow-scrolling: touch;z-index: 15;display: block}
  .suit-bottom{position: fixed;height: 50px;top: 0;left: 0;right: 0;background-color:white;z-index: 9;  }
  .bg-white{background:#ffffff}
  .magin-l-10{
    margin-left: 10px;
  }

  .suit-name{  height: 40px;  line-height: 40px;  border-bottom: 1px solid rgba(222, 216, 181, 0.66);;  }
  .suit-price{  height: 40px;  line-height: 40px;  background: #FDFCF8;  }
  .btm-btn{  height: 100%;  line-height: 50px;  }
  .menuItem{  border-bottom: 1px solid #EEE0CA;  }
  .menuItem:last-child{  border-bottom:none;  }
  .stands-item{  border-top: 1px solid #EEE0CA;  }
  .flex-wrap{display: flex;-webkit-flex-wrap: wrap;-moz-flex-wrap: wrap;-ms-flex-wrap: wrap;-o-flex-wrap: wrap;flex-wrap:wrap;}
  .nosuit-box{
    position:absolute;top:0;bottom: 0;left: 0;right: 0;overflow: hidden;z-index: 20;
  }
  .nosuitmodehead{
    position:absolute;top:0;bottom: 0;left: 0;right: 0;height: 118px;
  }
  .nosuitmodecontent{
    position:absolute;top:118px;bottom: 0;left: 0;right: 0;
  }
  .font-1-2{font-size: 1.2em;}
  .text-center{text-align: center}
  .flex-layout{ display: flex;  align-items: center;}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .color-yellow{color:#FF6D00}
  .font-1{font-size: 1em;}
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .color-blue{color:#00ABF8}
  .text-right{text-align: right}
  .suit-num{  display: inline-block;  border-radius: 3px;   text-align: center; min-width: 30px }
  .bg-yellow{background: #F7F3E7;}
  .nosuit-sub-title{display: flex; flex-direction: row; justify-content: space-around}
  .nosuit-sidedish-item{display: flex; flex-direction: row; justify-content: space-between; flex-wrap: wrap;}
  .width-auto{width: auto;}
  .padding-t-b-10{padding:10px 0;}
  .font-0-9{font-size: 0.9em;}
  .magin-l-6{
    margin-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/noSuitMode/nosuitmode.vue